import React, { memo, useEffect, useLayoutEffect, useRef, useState } from "react";
import * as utils from "./utils";
import Tooltip from "../PDFEditor/Tooltip";
import { nanoid } from "nanoid";
import { IoIosFlash, IoIosFlashOff } from "react-icons/io";
import { LuArrowBigLeft, LuArrowLeft } from "react-icons/lu";
// import "./style.css";
const SCALE = 620 / 80;
// const VIEWX = 80;
// const VIEWY = 80;

let defaultMaxRes;
const maxRes = {};
const getMaxRes = (device) => {
  const constraints = {
    // width: window.screen.availWidth,
    // height: window.screen.availHeight,
    facingMode: "environment",
    video: true,
    audio: false,
  };

  if (device) {
    if (maxRes[device]) return maxRes[device];
    constraints.deviceId = { exact: device };
  } else if (defaultMaxRes) return defaultMaxRes;

  const promise = navigator.mediaDevices.getUserMedia({ video: constraints }).then((media) => {
    const settings = media.getVideoTracks()[0].getSettings();
    for (const track of media.getTracks()) {
      track.stop();
    }

    // const width = Math.max(settings.width, settings.height);
    // const height = Math.min(settings.width, settings.height);

    const width = settings.width;
    const height = settings.height;

    console.log(media.getVideoTracks(), media, settings);
    return { width, height, deviceId: settings.deviceId };
  });

  if (device) maxRes[device] = promise;
  else
    defaultMaxRes = promise.then((value) => {
      maxRes[value.deviceId] = promise;
      return value;
    });

  return promise;
};

const startStream = async (device, options, compact) => {
  const maxRes = await getMaxRes(device);
  const aspectRatio = maxRes.width / maxRes.height;
  const landscape = utils.isLandscape(aspectRatio);

  const { width, height } = utils.calculateDims(aspectRatio, 1);
  const constraints = {
    width: compact ? maxRes.width + 44 : options.width || width,
    height: options.height || height,
    deviceId: { exact: maxRes.deviceId },
  };
  if (compact) delete constraints.height;

  const stream = await navigator.mediaDevices.getUserMedia({
    video: constraints,
  });

  const videoTrack = stream.getVideoTracks()[0];
  videoTrack.applyConstraints({ advanced: [{ torch: options.torch }] });
  const video = document.createElement("video");
  video.srcObject = stream;

  const canvas = document.getElementById("canvas");
  const ctx = canvas.getContext("2d");

  ctx.clearRect(0, 0, video.videoWidth, video.videoHeight);
  video.onloadedmetadata = () => {
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    video.play();
    setInterval(() => {
      ctx.drawImage(video, 0, 0);
    }, 10);
  };

  stream.stop = () => videoTrack.stop();

  return stream;
};

function ScannerApp(props) {
  const { width = 620, height = 620, container, isFullscreen, onCapture, compact, images, onClose } = props;
  const aspectRatio = width / height;
  const [torch, setTorch] = useState(!compact);
  const stream = useRef();

  const [size, setSize] = useState(() => {
    const style = getComputedStyle(container);
    const width = utils.unitParser(style.width, false) - (compact ? 0 : 370);
    const height = utils.unitParser(style.height, false) - (compact ? 0 : 260);
    return { width, height };
  });

  useLayoutEffect(() => {
    const style = getComputedStyle(container);
    const width = utils.unitParser(style.width, false) - (compact ? 0 : 370);
    const height = utils.unitParser(style.height, false) - (compact ? 0 : 260);
    setSize({ width, height });
  }, [container, isFullscreen]);

  useLayoutEffect(() => {
    let media;
    (async () => {
      if (stream.current)
        media = await startStream(
          localStorage.getItem("defaultDevice"),
          {
            width: size.width,
            height: size.height,
            torch,
          },
          compact
        );
      stream.current = media;
    })();
    return () => {
      if (media) {
        for (const track of media.getTracks()) {
          track.stop();
          console.log(track);
        }
      }
    };
  }, [size]);

  useEffect(() => {
    if (!stream.current) return;
    const videoTrack = stream.current.getVideoTracks()[0];
    videoTrack.applyConstraints({ advanced: [{ torch }] });
  }, [torch]);

  function handleCapture() {
    const canvas = document.getElementById("canvas");
    const data = utils.dataUrlTobase64(canvas.toDataURL());
    onCapture([{ id: nanoid(24), data, type: "image/png" }]);
  }

  function handleClose() {
    const videoTrack = stream.current.getVideoTracks()[0];
    videoTrack.applyConstraints({ advanced: [{ torch: false }] });
    onClose();
  }

  if (!compact) {
    return (
      <div className="flex flex-col items-center justify-between w-full h-full">
        <div className="flex items-center justify-center h-full w-full">
          <canvas id="canvas" />
        </div>
        <div className="flex items-center justify-center w-full p-8">
          <Tooltip label="Capture" side="top">
            <div
              className="w-[70px] h-[70px] bg-[#224b99] rounded-full border-[8px] border-solid border-[#e0ebff] cursor-pointer"
              onClick={handleCapture}
            />
          </Tooltip>
        </div>
      </div>
    );
  }
  return (
    <div className="flex flex-col items-center justify-between w-full h-full">
      <header className="flex items-center w-full p-4">
        <LuArrowLeft className="text-[24px]" onClick={handleClose} />
      </header>
      <div className="flex items-start justify-center h-full w-full">
        <canvas id="canvas" />
      </div>
      <div className="flex items-center justify-between w-full p-8 px-10">
        <div className="relative" onClick={handleClose}>
          <div className="rounded-full w-[48px] h-[48px] bg-slate-300 overflow-hidden">
            {images?.length ? (
              <div className="">
                <img className="w-fit" src={`data:${images.at(-1).type};base64,${images.at(-1).data}`} />
              </div>
            ) : null}
            <div className="absolute top-[-10px] right-[-10px] min-w-8 flex items-center justify-center rounded-full bg-[#224b99] text-[#fff]">
              {images?.length}
            </div>
          </div>
        </div>
        <div
          className="w-[70px] h-[70px] bg-[#224b99] rounded-full border-[8px] border-solid border-[#e0ebff] cursor-pointer"
          onClick={handleCapture}
        />
        <div onClick={() => setTorch(!torch)}>
          {torch ? <IoIosFlashOff className="text-[28px]" /> : <IoIosFlash className="text-[28px]" />}
        </div>
      </div>
    </div>
  );
}

const Scanner = memo(ScannerApp);
export default Scanner;
